import styled from "styled-components";
import { IoCheckmark } from "react-icons/io5";
import {singlePrice} from "../../../envs";
import {Button} from "@chakra-ui/react";
import {responsive} from "../../../media-quries";
import {useNavigate} from "react-router";

const Container = styled.div`
  background-color: white;
  border-radius: 30px;
  padding: 24px;
  color: black;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 3%;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  transition: transform 0.3s ease;
  flex-basis: 29%;

  ${responsive.lg`
  flex-basis: 31%;
  `}

  ${responsive.md`
  flex-basis: 47%;
  max-width: 333px;
  `}

  ${responsive.sm`
  flex-basis: 100%;
  max-width: 333px;
  `}
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:hover .chakra-button {
    background-color: #4f1629;
  }
`;
const Title = styled.p`
    font-size: 24px;
`;
const Price = styled.div`
  font-size: 38px;
  color: #6f1e3b;
  font-weight: 500;
`;
const Zl = styled.span`
  font-size: 24px;
`;
const Checklistcontainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const Check = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const BuyButton = styled(Button)`
  font-size: 16px;
  padding: 26px;
  border-radius: 16px;
  justify-self: flex-end;
`;
const CheckText = styled.span`
  text-align: left;
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

function PriceTile({ count, price }) {
    const singlePriceLocal = Math.round(price / count);
    const save = 100 - Math.round(singlePriceLocal / singlePrice * 100);
    const navigate = useNavigate();

    return <Container
        onClick={() => navigate('/zamowienie', {
            state: {
                order: {
                    type: 'package',
                    pack: {
                        count,
                        price
                    }
                }
            }
        })}>
        <ContentWrapper>
            {count === 1 ? <Title>Pojedyncze sprawdzenie</Title> : <Title>Pakiet {count} odkryć</Title>}
            <Price>{price} <Zl>zł</Zl></Price>
            <Checklistcontainer>
                {count !== 1 && <>
                    <Check>
                        <IoCheckmark size={24} color="#6f1e3b" />
                        <CheckText>Do wykorzystania w dowolnym czasie</CheckText>
                    </Check>
                    <Check>
                        <IoCheckmark size={24} color="#6f1e3b" />
                        <CheckText>Cena za 1 wyszukanie <b>{singlePriceLocal} zł</b></CheckText>
                    </Check>
                    <Check>
                        <IoCheckmark size={24} color="#6f1e3b" />
                        <CheckText>Oszczędzasz <b>{save}%</b></CheckText>
                    </Check>
                    <Check>
                        <IoCheckmark size={24} color="#6f1e3b" />
                        <CheckText>Wymaga założenia konta</CheckText>
                    </Check>
                </>}
                {count === 1 &&  <Check>
                    <IoCheckmark size={24} color="#6f1e3b" />
                    <CheckText>Nie wymaga założenia konta</CheckText>
                </Check>}
            </Checklistcontainer>
        </ContentWrapper>
        <BuyButton>Kup pakiet</BuyButton>
    </Container>
}

export default PriceTile
